import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';

const ScreeningParametersInfoSliderProductHeading = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <TitleWrapper $uppercase>{t('sti-product.what-screen-for')}</TitleWrapper>
    </Wrapper>
  );
};

export default ScreeningParametersInfoSliderProductHeading;

const Wrapper = styled.div``;

const TitleWrapper = styled.div<{ $uppercase?: boolean }>`
  color: ${Colors.navyBlue};
  font-family: BrownStd;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  letter-spacing: 1.5px;
  text-transform: ${({ $uppercase }) => ($uppercase ? 'uppercase' : 'none')};
`;
